import axios from 'axios';

export const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:3001';
export const WS_URL   = process.env.REACT_APP_WS_URL  || 'http://localhost:3001';
export const API_KEY  = process.env.REACT_APP_API_KEY  || 'demo';

export const api = axios.create({
  baseURL: `${API_BASE}/v1`,
  headers: { 'X-API-Key': API_KEY },
});
